import { FC, ReactNode, CSSProperties } from "react"

import { createPropsToClassNamesMapper, STYLE_PROPS } from "components/utils"

const styleMapper = createPropsToClassNamesMapper([
    ...STYLE_PROPS.SPACE.MARGIN,
    ...STYLE_PROPS.SPACE.PADDING,
    ...STYLE_PROPS.DISPLAY,
    ...STYLE_PROPS.TEXT,
    ...STYLE_PROPS.COLOR,
])

// VARIANTS: h1, h2, h3, h4, main, secondary, small

const variantsDefaultProps: Record<string, { tag: keyof JSX.IntrinsicElements } & CSSProperties> = {
    h1: {
        fontSize: 8,
        tag: "h1",
        lineHeight: 1,
        fontWeight: 1,
    },
    h2: {
        fontSize: 7,
        tag: "h2",
        lineHeight: 1,
        fontWeight: 1,
    },
    h3: {
        fontSize: 6,
        tag: "h3",
        lineHeight: 1,
        fontWeight: 1,
    },
    h4: {
        fontSize: 5,
        tag: "h4",
        lineHeight: 1,
        fontWeight: 1,
    },
    main: {
        fontSize: 4,
        tag: "span",
        lineHeight: 2,
        fontWeight: 0,
    },
    secondary: {
        fontSize: 4,
        tag: "span",
        lineHeight: 2,
        fontWeight: 0,
        color: "blue-3",
    },
    small: {
        fontSize: 3,
        tag: "span",
        lineHeight: 1,
        fontWeight: 0,
        color: "blue-3",
    },
}

// tag: any html tag or component that have className prop

const tagDefaultProps: Partial<Record<keyof JSX.IntrinsicElements, object>> = {
    h1: { display: "block" },
    h2: { display: "block" },
    h3: { display: "block", mb: 3 },
    h4: { display: "block" },
    p: { display: "block", mb: 3 },
}

interface TextProps {
    variant?: keyof typeof variantsDefaultProps
    children: ReactNode
    tag?: keyof JSX.IntrinsicElements
    color?: string
    mb?: Partial<Record<"xs" | "md" | "lg", number>> | number
    mr?: number
    px?: number
    lineHeight?: number
    fontWeight?: number
    fontSize?: number
    nowrap?: boolean
}

export const Text: FC<TextProps> = ({ variant = "main", children, tag, ...rawProps }) => {
    const Tag = tag || variantsDefaultProps[variant].tag
    const props = {
        ...variantsDefaultProps[variant],
        ...tagDefaultProps[Tag],
        ...rawProps,
    }

    return <Tag className={`font-futura-400 ${styleMapper(props)}`}>{children}</Tag>
}
